import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updownArrow } from "shared/assets/icons";
import PaginationListHOC from "../public/HOC/PaginationListHOC";
import "./Bidding.scss"
const fields = {
    "won": { field: "maxproxyprice",  direction: "asc" },
    "not-won": { field: "maxproxyprice", direction: "desc" },
    "closing-soon": { field: "itemclosetime",  direction: "asc" },
    "lowest-price": { field: "bidprice",  direction: "asc" },
    "highest-price": { field: "bidprice",  direction: "desc" },
};
const pageSize = 48
export default function Bidding({history}) {
    const dispatch  = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const [configeredData, setconfigeredData] = useState({
    })
    const [filterData, setfilterData] = useState({
        sortkey:"closing-soon",
        won:false,
        notwon:false
    })
    useEffect(() => {
        let data = filterData
        if (statemaintenance?.["Activebids"]) {
            if (statemaintenance?.["Activebids"]?.filterData != filterData) {
                data= statemaintenance?.["Activebids"]?.filterData
            }
        }
        onapplyFilter(data)
    
      return () => {
      }
    }, [])
    

    
    const onapplyFilter = (filtervalues) => {
    setfilterData(filtervalues)
        let filter = []
        let sort =  [{ "field": "itemclosetime", "direction": "asc" }]
        if(filtervalues?.won || filtervalues?.notwon) {
            if (filtervalues?.won) {
                filter.push({ "field": "biddingstatus", "value": "Won", "op": "=", "join": "AND" });
            }
            if (filtervalues?.notwon) {
                filter.push({ "field": "biddingstatus", "value": "Not Won", "op": "=", "join": "AND" });
            }
        }
        //  else {
        //     filter.push({ "field": "biddingstatus", "value": "Won", "op": "=", "join": "OR" });
        //     filter.push({ "field": "biddingstatus", "value": "Not Won", "op": "=", "join": "OR" });
        // }
        if(filtervalues?.sortkey != ""){
            sort = [fields[filtervalues?.sortkey]]
        }
        let payload = {
            "sort": sort,
            "page": { "size": pageSize },
            "filter": filter
        }
        let pusttoStore = { ...statemaintenance }
        pusttoStore["Activebids"] = {
            ...pusttoStore?.["Activebids"],
            filterData:filtervalues

        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setconfigeredData({
            payload,
            count: 4,
            pageSize: pageSize,
            type: "Bidding",
            history: history,
            heading: "Activebids"
        })
    }
    return (
        <div className="px-5">
            <div className="d-flex justify-content-between">
                <div className="d-md-flex align-items-center justify-content-between w-100 mt-5">
                    <div className="sorbyHOC">
                        <Form.Group controlId="sort-by">
                            <Form.Label className="sort-label">Sort by</Form.Label>
                            <Form.Select as="select" aria-label='sort by' className="sort" onChange={(event)=>{
                                 onapplyFilter({
                                    ...filterData,
                                    sortkey:event?.target?.value
                                })
                            }} value={filterData?.sortkey}>
                                <option value="closing-soon">Closing soon</option>
                                <option value="lowest-price">Lowest Price</option>
                                <option value="highest-price">Highest Price</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="d-flex align-items-center top-right gap-4 mt-3">
                        <div className={`d-flex align-items-center select-all-div clickable `}>
                            <Form.Check
                                type="checkbox"
                                id="wonSelect"
                                label="Winning"
                                name="won"
                                custom
                                checked={filterData?.won}
                                aria-label='winning'
                                onChange={()=>{
                                    onapplyFilter({
                                        ...filterData,
                                        won:!filterData?.won,
                                        notwon: !filterData?.won ? false : filterData?.notwon
                                    })
                                }}
                            />
                        </div>
                        <div className={`d-flex align-items-center select-all-div clickable`}>
                            <Form.Check
                                type="checkbox"
                                id="notWonSelect"
                                label="Not winning"
                                name="notwon"
                                custom
                                checked={filterData?.notwon}
                                aria-label='not winning'
                                onChange={()=>{
                                    onapplyFilter({
                                        ...filterData,
                                        notwon:!filterData?.notwon,
                                        won: !filterData?.notwon ? false : filterData?.won
                                    })
                                }}
                            />
                        </div>
                       
                    </div>
                </div>
            </div>
            <PaginationListHOC
                config={configeredData}
                emptyCont={<div className='d-flex align-items-center flex-column text-center text-secondary'>
                    <div className='emptycont'>No active bids to display yet. Items you are winning or losing will be shown here.  </div>
                </div>}
            />
        </div>
    )
}